import React from 'react'

const History = () => {
  return (
    <div>
      <div>
        <h3>Working with words</h3>
        <p className='question'>A. Match the words with their definitions/meanings.</p>
        <p>a. passion ------ any powerful or compelling emotion or feeling, as love or hate</p>
        <p>b. surveillance ------ continuous observation of a place, person, group, or ongoing activity in order to gather information</p>
        <p>c. integrity ------ the state of being whole, entire, or undiminished</p>
        <p>d. avuncular ------ like an uncle</p>
        <p>e. livelihood ------ a means of supporting one's existence</p>
        <p>f. fascination ------ powerful attraction</p>
        <p>g. innovation ------ an idea, practice, or object that is perceived as new</p>
        <p>h. panorama ------ an unobstructed and wide view of an extensive area in all directions</p>
        <p>i. resilience ------ the power or ability of a material to return to its original form, position, etc., after being bent, compressed, or stretched</p>
        <p>j. evacuation ------ the removal of people or things from an endangered area</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Define the following professionals. One has been done for you.</p>
        <br/>
        <p><strong>architect: </strong>An architect is an engineer who designs buildings and advises in their construction.</p>
        <br/>
        <p><strong>civil engineer: </strong>A civil engineer is a professional who designs, builds, and maintains roads, bridges, buildings, and other public structures.</p>
        <br/>
        <p><strong>mechanical engineer: </strong>A mechanical engineer is a professional who designs, develops, and tests machines and mechanical systems like engines, tools, and machines.</p>
        <br/>
        <p><strong>aerospace engineer: </strong>An aerospace engineer is a professional who designs and develops aircraft, spacecraft, satellites, and related systems and equipment.</p>
        <br/>
        <p><strong>automobile engineer: </strong>An automobile engineer is a professional who designs, develops, tests, and improves vehicles like cars, buses, and trucks.</p>
        <br/>
        <p><strong>electronic engineer: </strong>An electronic engineer is a professional who designs and develops electronic devices and systems, such as circuits, microchips, and communication equipment.</p>
        <br/>
        <p><strong>electrical engineer: </strong>An electrical engineer is a professional who designs, develops, and maintains electrical systems and equipment like power generators, wiring, and motors.</p>
        <br/>
        <p><strong>computer engineer: </strong>A computer engineer is a professional who designs, develops, and tests computer hardware and software systems.</p>
        <br/>
        <p><strong>food engineer: </strong>A food engineer is a professional who applies engineering principles to develop and improve food processing, packaging, and storage.</p>
        <br/>
        <p><strong>chemical engineer: </strong>A chemical engineer is a professional who uses chemistry and engineering to design processes for producing chemicals, fuels, medicines, and other products.</p>
        <br/>
        <p><strong>biomedical engineer: </strong>A biomedical engineer is a professional who designs and develops medical equipment, devices, and software to improve healthcare.</p>
        
      </div>
      <div>
        <hr />
        <h3>Comprehension</h3>
         <p className='question'>Answer the following questions.</p>
         <p className='question'>a. Where were Frank and Nicole employed?</p>
         <p>= Frank and Nicole were employed as architects working in the twin towers of the World Trade Centre in the USA.</p>

         <p className='question'>b. How does the author describe Frank's attachment to the twin towers?</p>
         <p>= The author shows that Frank feels deeply connected to the twin towers. For him, they are not just buildings but a source of his work and passion. The towers represent his livelihood and something he truly cares about, making his bond with them very strong.</p>

         <p className='question'>c. How did the two families become intimate with each other?</p>
         <p>= The two families grew close and became good friends because their children were friends. Their children's friendship helped the families spend more time together and build a strong bond.</p>

         <p className='question'>d. What, according to Nicole, did Frank think of the towers?</p>
         <p>= According to Nicole, Frank thought the towers were amazing. He liked how big they were, how they were designed, and how the materials were used well. He also said they were made strong enough to handle a small airplane hitting them.</p>

         <p className='question'>e. Why did Frank want to help the people in the tower after the attack?</p>
         <p>= Frank wanted to help the people in the tower after the attack because only a few people understood how strong the building was. He believed that knowing this could save lives.</p>
         <p className='question'>f. Why did Frank not follow Nicole's request even after knowing that the building was on fire?</p>
         <p>= Frank did not follow Nicole's request, even though he knew the building was on fire, because he was confident he could help the injured people get to safety without getting hurt himself.</p>

         <p className='question'>g. Who did Frank call from the building after the attack?</p>
         <p>= Frank called his sister Nina, who lived on West 93rd Street in Manhattan, from the building after the attack.</p>

         <p className='question'>h. How did Nicole feel after the collapse of the first tower?</p>
         <p>= After the first tower collapsed, Nicole felt like it was the start of a nuclear war. Everything became completely quiet, and she felt like she was in a bright, blinding fog, like a snowstorm on a sunny day.</p>

         <p className='question'>i. Were Frank's children serious as soon as they heard the news of their missing father? Why?</p>
         <p>= Frank's children were not serious right away when they heard their father was missing because they were busy playing games and did not fully understand the situation at first.</p>
      </div>
      <div>

        <hr/>
        <h3>Critical Thinking</h3>
        <p className='question'>a. Many innocent people lose their lives in ruthless attacks every year. What do you think the governments should do to protect their people from such attacks and make the world a safer place to live? Discuss with your friends.</p>
        <p>= Many innocent people lose their lives every year due to ruthless attacks. It is the responsibility of governments to protect their citizens and work towards a safer world. Here are some important steps governments should take:
</p><p>
1. Maintain Political Stability
Governments should ensure stability within their own countries by having strong and responsible leadership and peaceful political parties. Stability helps prevent internal conflicts that can lead to violence.
</p><p>
2. Control Borders Strictly
Proper border control and security checks can help prevent dangerous people or weapons from entering a country. This reduces the risk of attacks.
</p><p>
3. Deploy Armed Forces in High-Risk Areas
Governments should place security forces in places that are more likely to be attacked. This helps to respond quickly and prevent attacks.
</p><p>
4. Promote and Follow Peace Treaties
While many peace agreements are signed, they are not always followed. Nations should commit to maintaining peace and resolving conflicts through dialogue instead of violence.
</p><p>
5. Evacuate People from Danger Zones
If there is a threat or danger, governments should move people to safer places to protect their lives.
</p><p>
By taking these steps, governments can work together to reduce violence and make the world a safer place for everyone.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Revenge and violence are the integral parts of the history and civilization. They can't be ignored, only managed. Do you agree or not with this statement? Present your logic.</p>
        <p>= Yes, I agree with the statement that revenge and violence are integral parts of history and civilization. Revenge often arises from feelings of hurt and injustice, while violence involves the use of physical force to injure, damage, or destroy. Throughout history, acts of revenge and violence have played significant roles in shaping events and societies.
</p><p>
For example, one of the main causes of World War II was the desire for revenge by Germany. After World War I ended in 1919, the Treaty of Versailles imposed harsh penalties and heavy reparations on Germany. This treaty humiliated Germany and blamed it entirely for the war. The resentment and anger that grew from this situation eventually led Germany to seek revenge, which triggered the outbreak of World War II in 1939.
</p><p>
This example shows how revenge and violence have led to destructive consequences and widespread suffering. Because such emotions and actions are deeply rooted in human nature and social dynamics, they cannot simply be ignored. Instead, it is necessary to recognize and manage them carefully through laws, diplomacy, and education to prevent escalation and promote peace.</p>
      </div>
      <div>
        <hr/>
        <h3>Writing</h3>
        <p className='question'>A. Write a description of an event that you have recently witnessed.</p>
        <p>= Recently, I went to my village called Gaira Gau. It is on top of a green hill. The roads there are narrow, bumpy, and have sharp turns. That day, it was raining.
</p><p>
While I was returning home from the village, my bus was going down the hill. At the same time, another bus was coming up from the opposite direction. Suddenly, the other bus slipped, its front tire lost grip on the hill. Everyone became very tense and worried.
</p><p>
Because our bus was behind that bus, we got out quickly to help. First, we helped the people inside the stuck bus get out safely. Then, we tied a rope to their bus and pulled it carefully using our bus. After some effort, we managed to get the bus back on the road.
</p><p>
It was a scary moment, but everyone worked together to stay safe.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Human life does not pass as one expects. You might have also gone through different but memorable incidents. Write an essay on “An Unforgettable Event in my Life' in about 500 words.</p>
        <p>= Human life does not always go as we expect. We often face different moments that stay in our memory forever. One such unforgettable event in my life was the birth of my little sister.
</p><p>
At that time, I was studying in grade 5. It was an ordinary school day, and I went to school like usual. When I returned home, I saw my mother in great pain. She was struggling, and I felt worried and scared. My family quickly called two nurses to help her. They came to our house and took care of my mother.
</p><p>
Because my mother was in pain, the nurses asked me to go to the neighbor's house for a while. I was alone there, feeling very frightened. I cried a lot, hoping that my mother would be okay. In my heart, I felt angry at the baby growing inside my mother because it was causing her so much pain. I did not understand then how important that little baby was.
</p><p>
After some time, the nurses called me back to our home. When I came inside, I saw my mother lying down. She looked tired but also half happy. Next to her was a tiny baby — my little sister. She was so small, with a little hand and a tiny face. Seeing her made me forget all the fear and anger I had before.
</p><p>
I felt very happy to see both my mother and my new sister safe and healthy. I went to my mother and hugged her tightly. At that moment, I realized how special my sister was and how strong my mother had been. All the pain and fear had changed into love and joy.
</p><p>
That event taught me many things. It showed me the power of love and care in a family. I understood how much my mother had gone through to bring a new life into the world. I also learned that sometimes, we might feel scared or angry, but these feelings can change when we see the happiness and miracles around us.
</p><p>
The birth of my little sister is a memory I will never forget. It changed my life and made me feel closer to my family. Whenever I look at my sister now, I remember that day and the strong love that brought us all together.</p>
      </div>
      <div>
        <hr/>
        <h3>Grammar</h3>
        <p className='question'>B. Complete these sentences with the correct prepositions.</p>
        <p>a. The relationship <strong>between</strong> the two boys has changed significantly over the past few years.</p>
        <p>b. In Nepal, many girls get married <strong>at</strong> an early age.</p>
        <p>c. I'm not <strong>in</strong>the mood for such silly games.</p>
        <p>d. There were no security personnel <strong>on </strong>duty at that time.</p>
        <p>e. The new smartphone is similar <strong>to</strong> the one I bought a few years ago.</p>
        <p>f. My dad insisted <strong> on </strong>taking the later train.</p>
        <p>g. People <strong>with </strong>ambition always try to achieve their goals, no matter what happens.</p>
        <p>h. Mr. Jenkins has been disabled all his life as a result <strong>of </strong>a childhood illness.</p>
        <p>i. We bought the TV because it was <strong>on</strong> sale.</p>
        <p>j. She has no understanding <strong>of</strong> how computers really work.</p>
        <p>k. I gave him my new T-shirt in exchange <strong>for</strong> a few cigarettes.</p>
        <p>l. The company is run<strong> by </strong>two people who hardly ever meet.</p>
        <p>m. All the celebrations and parties were called <strong>off</strong> because of the tragic accident.</p>
        <p>n. There was a great need <strong>of</strong> volunteers at the site of the crash</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Complete the following text with correct prepositions.</p>
        <p>What are we seeing here? One very real possibility is that these are the educational consequences of the differences <strong>in</strong> parenting styles that we talked about <strong>in</strong> the Chris Langan chapter. Think back to Alex Williams, the nine-year-old whom Annette Lareau studied. His parents believe <strong>in</strong> connected cultivation. He gets taken <strong>to</strong> museums and gets enrolled <strong>in</strong> special programs and goes <strong>to</strong> summer camp, where he takes classes. When he's bored <strong>at</strong> home, there are plenty of books to read, and his parents see it as their responsibility to keep him actively engaged <strong>in</strong>the world <strong>for</strong> him. It's hard to see how Alex would get better <strong>at</strong> reading and math <strong>in</strong> the summer.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>Simple future, future continuous, future perfect and future perfect continuous</p>
        <p className='question'>B. make sentences from the given clues as stated in brackets.</p>
        <p>a. Who/pass the exam? (future simple)</p>
        <p>Who will pass the exam?</p>
        <br/>
        <p>b. How/you/get home? (future continuous)</p>
        <p>How will you be getting home?</p>
        <br/>
        <p>c. I/come later. (future simple)</p>
        <p>I'll come later.</p>
        <br/>
        <p>d. She/catch the train by 3 pm. (future perfect)</p>
        <p>She will have caught the train by 3 PM.</p>
        <br/>
        <p>e. It/rain tomorrow. (future simple)</p>
        <p>It will rain tomorrow.</p>
        <br/>
        <p>f. John/sleep at 4 am. (future continuous)</p>
        <p>John will be sleeping at 4 am.</p>
        <br/>
        <p>g. How long/you/see your boyfriend when you get married? (future perfect continuous)</p>
        <p>How long will you have been seeing your boyfriend when you get married?</p>
        <br/>
        <p>h. It/rain in Kathmandu next week. (future continuous)</p>
        <p>It will be raining in Kathmandu next week.</p>
        <br/>
        <p>i. How long/you/work here when you retire? (future perfect continuous)</p>
        <p>How long have you been working here when you retire?</p>
        <br/>
        <p>j. He/not/finish the cleaning by the time she gets home. (future perfect)</p>
        <p>He won't have finished the cleaning by the time she gets home.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Complete the following sentences with the correct future tense form of the verbs in the brackets.</p>
         <p>a. It will snow (snow) in Brighton tomorrow evening.</p>
         <br/>
          <p>b. On Friday at 8 o'clock, I'm going to meet (to meet) my friend.</p>
          <br/>
        <p>c. Wait! I will drive (to drive) you to the station.</p>
        <br/>
         <p>d. When they get married in March, they will have been (to be) together for six years</p>
         <br/>
          <p>e. You're carrying too much. I will open (to open) the door for you.</p>
          <br/>
           <p>f. Do you think the teacher will have marked (to mark) our homework by Monday morning?</p>
           <br/>
            <p>g. When I see you tomorrow, I will show (show) you my new book.</p>
            <br/>
             <p>h. After you take a nap, you will feel (to feel) a lot better.</p>
             <br/>
              <p>i. I will let (to let) you know the second the builders finish decorating.</p>
              <br/>   
               <p>j. We will wait (to wait) in the shelter until the bus comes.</p>
               <br/>
              <p>k. I'm very sorry, Dr. Jones won't be (not be) back in the clinic unit 2 pm.</p>
              <br/>
               <p>l. This summer, I will have been living (to live) in Birgunj for four years.</p>
               <br/>
                <p>m. I don't think you will have (to have) any problems when you land in Pokhara.</p>
                <br/>
                 <p>n. The baby should be due soon, next week she will have been (to be) pregnant for nine months.</p>
                 <br/>
                  <p>o. By the time we get home, they will have been playing (to play) football for 30 minutes.</p>
                  <br/>
                   <p>p. When you get off the train, I will be waiting (to wait) for you by the ticket machine.</p>
                   <br/>
                    <p>q. This time next week, I will be skiing (ski) in Switzerland!</p>
                    <br/>
                    <p>r. Now, I am going to check (to check) my answers.</p>
      </div>
       </div>
  )
}

export default History
